export default __webpack_public_path__ + "static/media/phone.30deda7b.svg";